module.exports = __webpack_public_path__ + "img/kommission.c3251193.png";